import {
  Box,
  Heading,
  Text,
  SimpleGrid,
  Stack,
  Badge,
  Flex,
  HStack,
  Icon,
  Card,
  CardBody,
Tabs,
TabList,
TabPanels,
Tab,
TabPanel,
Table,
Thead,
Tbody,
Tr,
Th,
Td,
Spinner
} from "@chakra-ui/react";
import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { getVendorDetails } from "../../../actions/inventory/vendor.action";

import { Link as RouterLink } from "react-router-dom";

import {
  getVendorFleets,
  getVendorDrivers,
  getVendorTrips,
  getVendorAuditLogs,
} from "../../../actions/inventory/vendor.action";

import { DocumentCard } from "../../../components/DocumentImageViewer";
import { Loading } from "../../../components/Loading";
import BreadCrumbMaker from "../../../components/BreadCrumbMaker";
import { FaStar } from "react-icons/fa";

const vendorStatusMap = {
  active: "Active",
  inactive: "Inactive",
  suspended: "Suspended",
  under_review: "Under Review",
};

const statusColorMap = {
  active: "green",
  inactive: "gray",
  suspended: "red",
  under_review: "yellow",
};



const VendorFleets = ({ vendorId }) => {
  const [fleets, setFleets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFleets = async () => {
      try {
        const res = await getVendorFleets(vendorId);
        setFleets(res?.fleets || []);
      } catch (err) {
        console.error("Failed to fetch fleets", err);
      } finally {
        setLoading(false);
      }
    };
    if (vendorId) fetchFleets();
  }, [vendorId]);

  if (loading) return <Spinner />;
  if (fleets.length === 0) return <Text color="gray.500">No vehicles found.</Text>;

  return (
    <Box overflowX="auto" w="full">
      <Table variant="simple" size="sm" w="full">
        <Thead>
          <Tr>
            <Th>Vehicle No.</Th>
            <Th>Model</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {fleets.map((fleet) => (
            <Tr key={fleet._id}>
              <Td>
                <Text as={RouterLink} to={"/fleet-management/vehicles/" + fleet._id} color="blue.500" fontWeight="medium">
                  {fleet.vehicleNumber}
                </Text>
              </Td>
              <Td>{fleet.model}</Td>
              <Td>{fleet.status?.operationalStatus}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

const VendorDrivers = ({ vendorId }) => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const res = await getVendorDrivers(vendorId);
        setDrivers(res?.drivers || []);
      } catch (err) {
        console.error("Failed to fetch drivers", err);
      } finally {
        setLoading(false);
      }
    };
    if (vendorId) fetchDrivers();
  }, [vendorId]);

  if (loading) return <Spinner />;
  if (drivers.length === 0) return <Text color="gray.500">No drivers found.</Text>;

  return (
    <Box overflowX="auto" w="full">
      <Table variant="simple" size="sm" w="full">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Mobile</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {drivers.map((driver) => (
            <Tr key={driver._id}>
              <Td>
                <Text as={RouterLink} to={"/fleet-management/driver/" + driver._id} color="blue.500" fontWeight="medium">
                  {driver.name}
                </Text>
              </Td>
              <Td>{driver.contactDetails?.mobileNumber}</Td>
              <Td>{driver.aditionalDetails?.operationalStatus}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

const VendorTrips = ({ vendorId }) => {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const res = await getVendorTrips(vendorId);
        setTrips(res?.trips || []);
      } catch (err) {
        console.error("Failed to fetch trips", err);
      } finally {
        setLoading(false);
      }
    };
    if (vendorId) fetchTrips();
  }, [vendorId]);

  if (loading) return <Spinner />;
  if (trips.length === 0) return <Text color="gray.500">No trips found.</Text>;

  return (
    <Box overflowX="auto" w="full">
      <Table variant="simple" size="sm" w="full">
        <Thead>
          <Tr>
            <Th>Trip Code</Th>
            <Th>Status</Th>
            <Th>Date</Th>
          </Tr>
        </Thead>
        <Tbody>
          {trips.map((trip) => (
            <Tr key={trip._id}>
              <Td>
                <Text as={RouterLink} to={"/bookings/" + (trip.bookingId?._id || trip.bookingId)} color="blue.500" fontWeight="medium">
                  {trip.tripCode}
                </Text>
              </Td>
              <Td>{trip.tripStatus}</Td>
              <Td>{new Date(trip.createdAt).toLocaleDateString()}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};

const VendorAuditLogs = ({ vendorId }) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await getVendorAuditLogs(vendorId);
        setLogs(res?.data || []);
      } catch (err) {
        console.error("Failed to fetch logs", err);
      } finally {
        setLoading(false);
      }
    };
    if (vendorId) fetchLogs();
  }, [vendorId]);

  if (loading) return <Spinner />;
  if (logs.length === 0) return <Text color="gray.500">No logs found.</Text>;

  return (
    <Box overflowX="auto" w="full">
      <Table variant="simple" size="sm" w="full">
        <Thead>
          <Tr>
            <Th>Date & Time</Th>
            <Th>Action</Th>
            <Th>Performed By</Th>
            <Th>Changes Summary</Th>
          </Tr>
        </Thead>
        <Tbody>
          {logs.map((log) => (
            <Tr key={log._id}>
              <Td>{new Date(log.createdAt).toLocaleString()}</Td>
              <Td>{log.actionType}</Td>
              <Td>{log.performedByInfo?.name}</Td>
              <Td maxW="300px"><Text noOfLines={2}>{log.changesDescription}</Text></Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
};


const VendorEach = () => {
  const { id } = useParams();
  const location = useLocation();
  const [vendor, setVendor] = useState(location?.state?.driverData || null);
  const [loading, setLoading] = useState(!location?.state?.driverData);

  const fetchVendorDetails = async () => {
    try {
      const res = await getVendorDetails(id);
      console.log("Vendor Details by id :", res.data);
      setVendor(res?.data?.data || res?.data || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const InfoItem = ({ label, value, icon }) => (
    <Box>
      <HStack spacing={2} mb={1}>
        {icon && <Icon as={icon} color="blue.500" boxSize={4} />}
        <Text fontSize="sm" color="gray.500" fontWeight="medium">
          {label}
        </Text>
      </HStack>
      <Text fontWeight="semibold" fontSize="md">
        {value || "-"}
      </Text>
    </Box>
  );

  const CertificateCard = ({ label, imageUrl }) => (
    <DocumentCard label={label} imageUrl={imageUrl} />
  );

  useEffect(() => {
    // Only fetch if data wasn't passed via location state
    if (!vendor && id) {
      fetchVendorDetails();
    }
  }, [id, vendor]);

  if (loading) {
    return <Loading />;
  }

  if (!vendor) {
    return (
      <Box textAlign="center" p={10}>
        <Text fontSize="xl" color="gray.600">
          No vendor data found
        </Text>
      </Box>
    );
  }

  return (
    <>
      <Box p={{ base: 4, md: 6 }} maxW="1200px" mx="auto" w="100%">
        {/* Breadcrumbs */}
        <BreadCrumbMaker
          items={[
            { title: "Fleet Management", link: "#" },
            { title: "Vendors", link: "/fleet-management/vendor" },
            { title: "View Vendor", link: `/fleet-management/vendor/${id}`, on: true },
          ]}
        />

        <Box mb={6} mt={6}>
          <Flex justifyContent="space-between" alignItems="center">
            <Heading size="sm" mb={2} color="#1E2A5A">
              Vendor Information
            </Heading>
            <HStack spacing={4}>
              <HStack spacing={1}>
                <FaStar color="#FFD700" />
                <Text fontWeight="semibold">{vendor?.vendorRating?.toFixed(1) || "0.0"}</Text>
              </HStack>
              <Badge
                colorScheme={statusColorMap[vendor?.vendorStatus] || "gray"}
                px={3}
                py={1}
                rounded="lg"
              >
                {vendorStatusMap[vendor?.vendorStatus] || vendor?.vendorStatus || "Under Review"}
              </Badge>
            </HStack>
          </Flex>
        </Box>
        <Tabs colorScheme="blue" variant="unstyled" mt={4}>
          <TabList
            overflowX="auto"
            sx={{
              "&::-webkit-scrollbar": { display: "none" },
              msOverflowStyle: "none",
              scrollbarWidth: "none",
            }}
          >
            <Tab fontWeight="medium" border="1px solid" borderColor="#396AFF" color="#396AFF" _selected={{ color: "white", bg: "#396AFF" }} mr={2} borderRadius="md" whiteSpace="nowrap" flexShrink={0}>Profile and Documents</Tab>
            <Tab fontWeight="medium" border="1px solid" borderColor="#396AFF" color="#396AFF" _selected={{ color: "white", bg: "#396AFF" }} mr={2} borderRadius="md" whiteSpace="nowrap" flexShrink={0}>Vehicles</Tab>
            <Tab fontWeight="medium" border="1px solid" borderColor="#396AFF" color="#396AFF" _selected={{ color: "white", bg: "#396AFF" }} mr={2} borderRadius="md" whiteSpace="nowrap" flexShrink={0}>Drivers</Tab>
            <Tab fontWeight="medium" border="1px solid" borderColor="#396AFF" color="#396AFF" _selected={{ color: "white", bg: "#396AFF" }} mr={2} borderRadius="md" whiteSpace="nowrap" flexShrink={0}>Trips</Tab>
            <Tab fontWeight="medium" border="1px solid" borderColor="#396AFF" color="#396AFF" _selected={{ color: "white", bg: "#396AFF" }} borderRadius="md" whiteSpace="nowrap" flexShrink={0}>Audit Log</Tab>
          </TabList>
          <TabPanels>
            <TabPanel px={0} pt={6}>
              <Card borderRadius="xl" boxShadow="sm" mb={6}>
                <CardBody p={{ base: 4, md: 6 }}>
            <Heading size="sm" color="gray.700" mb={6}>
              Vendor Information
            </Heading>

            <SimpleGrid
              columns={{ base: 1, md: 4 }}
              spacing={{ base: 4, md: 6 }}
              mb={6}
            >
              <InfoItem label="Vendor ID" value={vendor.uniqueVendorCode} />
              <InfoItem label="Vendor Name" value={vendor.vendorName} />
              <InfoItem label="Vendor Type" value={vendor.vendorType === "individual" ? "Individual/Sole Proprietorship" : vendor.vendorType === "organisation" ? "Organisation" : vendor.vendorType} />
              <InfoItem label="Mobile Number" value={vendor.phoneNumber} />
              <InfoItem label="WhatsApp Number" value={vendor.whatsappNumber} />
              <InfoItem label="Vendor Email" value={vendor.vendorEmail} />
            </SimpleGrid>

            {/* Individual KYC Section */}
            {vendor.vendorType === "individual" && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Individual KYC
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Aadhaar Number" value={vendor.aadhaarNumberIndividual} />
                  <InfoItem label="PAN Number" value={vendor.panNumberIndividual} />
                </SimpleGrid>

                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  GST Registration
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Trade Name" value={vendor.tradeNameIndividual} />
                  <InfoItem label="GSTIN" value={vendor.gstinIndividual} />
                  <InfoItem label="GST State" value={vendor.gstStateIndividual} />
                </SimpleGrid>
              </>
            )}

            {/* Organisation - Company KYC Section */}
            {vendor.vendorType === "organisation" && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Company KYC
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Company Name" value={vendor.companyName} />
                  {/* <InfoItem label="Organisation Type" value={vendor.organisationType} /> */}
                  <InfoItem label="Company PAN" value={vendor.companyPanNumber} />
                </SimpleGrid>
              </>
            )}

            {/* Organisation Address Section */}
            {vendor.vendorType === "organisation" && vendor.orgAddress && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Company Address
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Address" value={vendor.orgAddress?.address} />
                  <InfoItem label="City" value={vendor.orgAddress?.city} />
                  <InfoItem label="State" value={vendor.orgAddress?.state} />
                  <InfoItem label="Pincode" value={vendor.orgAddress?.pinCode} />
                  <InfoItem label="Country" value={vendor.orgAddress?.country} />
                </SimpleGrid>
              </>
            )}

            {/* Organisation - GST Registration Section */}
            {vendor.vendorType === "organisation" && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  GST Registration
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Trade Name" value={vendor.tradeNameOrganisation} />
                  <InfoItem label="GSTIN" value={vendor.gstin} />
                  <InfoItem label="GST State" value={vendor.gstState} />
                </SimpleGrid>
              </>
            )}

            {/* Organisation - Owner KYC Section */}
            {vendor.vendorType === "organisation" && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Owner KYC
                </Heading>
                <SimpleGrid
                  columns={{ base: 1, md: 4 }}
                  spacing={{ base: 4, md: 6 }}
                  mb={6}
                >
                  <InfoItem label="Owner Aadhaar Number" value={vendor.ownerAadhaarNumber} />
                  <InfoItem label="Owner PAN Number" value={vendor.ownerPanNumber} />
                </SimpleGrid>
              </>
            )}

            {/* Vendor Contacts Section */}
            {vendor.vendorType === "organisation" && vendor.vendorContacts?.length > 0 && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Vendor Contacts
                </Heading>
                {vendor.vendorContacts.map((contact, index) => (
                  <SimpleGrid
                    key={index}
                    columns={{ base: 1, md: 4 }}
                    spacing={{ base: 4, md: 6 }}
                    mb={4}
                    p={4}
                    bg="gray.50"
                    borderRadius="md"
                  >
                    <InfoItem label="Contact Name" value={contact.name} />
                    <InfoItem label="Mobile" value={contact.mobile} />
                    <InfoItem label="Email" value={contact.email} />
                  </SimpleGrid>
                ))}
              </>
            )}

            {/* Additional Details */}
            {vendor.additionalDetails && (
              <>
                <Heading size="sm" color="gray.700" mb={4} mt={6}>
                  Additional Details
                </Heading>
                <Text color="gray.600">{vendor.additionalDetails}</Text>
              </>
            )}

            <Heading size="sm" color="gray.700" mb={4} mt={6}>
              Documents
            </Heading>

            <SimpleGrid
              columns={{ base: 1, md: 4 }}
              spacing={{ base: 4, md: 6 }}
              mb={6}
            >
              {vendor.vendorType === "individual" && (
                <>
                  <CertificateCard
                    label="Aadhaar Card Front"
                    imageUrl={vendor.aadhaarCardFront}
                  />
                  <CertificateCard
                    label="Aadhaar Card Back"
                    imageUrl={vendor.aadhaarCardBack}
                  />
                  <CertificateCard
                    label="PAN Card Front"
                    imageUrl={vendor.panCardFront}
                  />
                  <CertificateCard
                    label="GST Certificate"
                    imageUrl={vendor.gstCertificate}
                  />
                </>
              )}
              {vendor.vendorType === "organisation" && (
                <>
                  <CertificateCard
                    label="Company PAN Card"
                    imageUrl={vendor.companyPanCardFront}
                  />
                  <CertificateCard
                    label="Owner Aadhaar Front"
                    imageUrl={vendor.aadhaarCardFront}
                  />
                  <CertificateCard
                    label="Owner Aadhaar Back"
                    imageUrl={vendor.aadhaarCardBack}
                  />
                  <CertificateCard
                    label="Owner PAN Card"
                    imageUrl={vendor.ownerPanCardFront}
                  />
                  <CertificateCard
                    label="GST Certificate"
                    imageUrl={vendor.gstCertificate}
                  />
                </>
              )}
            </SimpleGrid>
                </CardBody>
              </Card>
            </TabPanel>

            <TabPanel px={0} pt={6}>
              <Card borderRadius="xl" boxShadow="sm" w="full">
                <CardBody>
                  <Heading size="sm" color="gray.700" mb={6}>Vehicles</Heading>
                  <VendorFleets vendorId={vendor._id || id} />
                </CardBody>
              </Card>
            </TabPanel>

            <TabPanel px={0} pt={6}>
              <Card borderRadius="xl" boxShadow="sm" w="full">
                <CardBody>
                  <Heading size="sm" color="gray.700" mb={6}>Drivers</Heading>
                  <VendorDrivers vendorId={vendor._id || id} />
                </CardBody>
              </Card>
            </TabPanel>

            <TabPanel px={0} pt={6}>
              <Card borderRadius="xl" boxShadow="sm" w="full">
                <CardBody>
                  <Heading size="sm" color="gray.700" mb={6}>Trips</Heading>
                  <VendorTrips vendorId={vendor._id || id} />
                </CardBody>
              </Card>
            </TabPanel>

            <TabPanel px={0} pt={6}>
              <Card borderRadius="xl" boxShadow="sm" w="full">
                <CardBody>
                  <Heading size="sm" color="gray.700" mb={6}>Audit Log</Heading>
                  <VendorAuditLogs vendorId={vendor._id || id} />
                </CardBody>
              </Card>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
};

export default VendorEach;
